import {ThreePenalUnit} from '../ThreePenalUnit';
import {KitchenService} from '../../../../../services/KitchenService/KitchenService';
import {ThreePenalCorpus} from '../../../details/ThreeCorpus/types/ThreePenalCorpus';
import {ISavePenalUnitData} from '../../../../../../../common-code/interfaces/saveData/ISavePenalUnitData';
import {ISaveCorpusData} from '../../../../../../../common-code/interfaces/saveData/ISaveCorpusData';
import {CommonHelper} from 'common-code';

export class ThreePenalUnitNormal extends ThreePenalUnit {
    corpus: ThreePenalCorpus;

    constructor(options: ISavePenalUnitData, service: KitchenService) {
        super(options, service);
        this.corpus = this.initCorpus(options.corpus);
    }

    public initState(isRebuild?: boolean) {
        super.initState(isRebuild);
        // this.view3d.userData.transparentAngle = -0.4;
    }

    protected initCorpus(corpusData: ISaveCorpusData): ThreePenalCorpus {
        return new ThreePenalCorpus(CommonHelper.deepCopy(corpusData), this);
    }
}